import React from "react";
import WindowPattern from "./patterns/PatternSelector";
import ArchitecturalShapeSelector from "./ArchitecturalShapes";

const ArchitecturalDiagram = ({
  selectedValue,
  availableOptions,
  onChange,
  mode,
  disabled,
  formData,
  allAvailableOptions,
}) => {
  const fullWindowOption =
    availableOptions?.find(
      (opt) =>
        !opt.name.toLowerCase().includes("sash") &&
        !opt.name.toLowerCase().includes("lite")
    ) || availableOptions?.[0];

  const isSelected = selectedValue === fullWindowOption?.id;

  const handleClick = () => {
    if (disabled || mode === "display") return;
    onChange(isSelected ? null : fullWindowOption?.id);
  };

  const selectedGridStyle = allAvailableOptions?.grid_styles?.find(
    (style) => style.id === formData?.grid_style_id
  );

  const pattern = (
    <WindowPattern
      mode={mode}
      isSelected={isSelected}
      gridStyleName={selectedGridStyle?.name}
    />
  );

  return (
    <div className="flex flex-col justify-center items-center">
      <ArchitecturalShapeSelector
        architecturalStyle={formData?.architectural_style}
        onClick={handleClick}
        pattern={pattern}
        opacityClass={disabled ? "opacity-50" : ""}
      />
    </div>
  );
};

export default ArchitecturalDiagram;
